// extracted by mini-css-extract-plugin
export default {"statisticsButton":"s_statisticsButton__B7N0n","table":"s_table__yW+Ll"};